import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthFailedInterceptor } from './auth-failed-interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthFailedInterceptor, multi: true },
]